import projection from '../generated/pwj214f1.json';
import { AcceptanceManifest } from '../types';
export const pwj214f1AcceptanceManifest = projection as AcceptanceManifest;
